<template>
  <header
    id="header"
    class="row no-margin">
    <vue-progress-bar/>
    <div class="left row no-margin align-items-center">
      <div class="col">
        <router-link
          :to="{ name: 'Home'}"
          class="btn-backtohome">
          <i class="fas fa-th"/>
        </router-link>
      </div>
    </div>
    <div
      class="middle row align-items-center"
      style="padding-right: 10px;position: relative;">
      <div
        v-if="showDiv2 && getAppPrev.app_id"
        :class="[{'slideOutUp': animiated2}]"
        class="subheader col no-padding text-right animated fastest"
        style="margin-left: 15px;">
        <span>{{ $t('app.'+ getAppPrev.app_name +'.title') }}</span>
        <div
          :style="'background:' + $t('app.'+ getAppPrev.app_name +'.bgcolor')"
          class="icon-box">
          <i :class="$t('app.'+ getAppPrev.app_name +'.icon')"/>
        </div>
      </div>
      <div
        v-if="showDiv1"
        :class="[{'slideInDown': animiated1}]"
        class="subheader col no-padding text-right animated fast"
        style="margin-left: 15px;">
        <span>{{ $t('app.'+ getAppCurrent.app_name +'.title') }}</span>
        <div
          :style="'background:' + $t('app.'+ getAppCurrent.app_name +'.bgcolor')"
          class="icon-box">
          <i :class="$t('app.'+ getAppCurrent.app_name +'.icon')"/>
        </div>
      </div>
    </div>
    <button
      id="btn-show-sidebar-toggle"
      class="btn-no-bg">
      <i class="fas fa-bars"/>
    </button>
    <!-- <div
      v-if="project.config.node_env === 'development'"
      style="position: absolute;top: 15px;right: 10px;">
      <button
        class="btn btn-sm btn-web"
        @click="switchLang('th')">TH</button>
      <button
        class="btn btn-sm btn-web"
        @click="switchLang('en')">EN</button>
      <button
        class="btn btn-sm btn-web"
        @click="getShopId()">Get ShopId</button>
      <button
        class="btn btn-sm btn-web"
        @click="getAccessToken()">Get Acc Token</button>
      <button
        class="btn btn-sm btn-web"
        @click="getRefreshToken()">Get Ref Token</button>
    </div> -->
  </header>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Header',
  data () {
    return {
      animiated1: false,
      animiated2: false,
      showDiv1: true,
      showDiv2: false,
    }
  },
  computed: {
    ...mapGetters({
      auth: 'getAuth',
      getAppCurrent: 'getAppCurrent',
      getAppPrev: 'getAppPrev',
    }),
  },
  watch: {
    'getAppCurrent': {
      handler: function (after) {
        this.animiated1 = false
        this.animiated2 = false

        let that = this
        let foundPrevApp = that.getAppPrev.app_id

        if (foundPrevApp) {
          that.showDiv1 = false
          that.showDiv2 = true
          that.setAnimated2()
        } else {
          that.showDiv1 = true
          that.showDiv2 = false
        }

        setTimeout(() => {
          that.showDiv1 = true
          that.showDiv2 = false
          that.setAnimated()
        }, 200)
      },
      deep: true,
    },
  },
  created: function () {
    this.setAnimated()
  },
  destroyed: function () {
    // set prev
    this.$store.dispatch('setAppPrev', {
      app_name: null,
      app_id: null,
    })
    // set current
    this.$store.dispatch('setAppCurrent', {
      app_name: null,
      app_id: null,
    })
  },
  methods: {
    switchLang (lang) {
      // change lang
      this.$i18n.locale = lang
      // switch lang
      this.$store.dispatch('switchLang', lang)
    },
    getAccessToken () {
      window.prompt('Copy to clipboard: Ctrl+C, Enter', this.auth.access_token)
    },
    getRefreshToken () {
      window.prompt('Copy to clipboard: Ctrl+C, Enter', this.auth.refresh_token)
    },
    getShopId () {
      window.prompt('Copy to clipboard: Ctrl+C, Enter', this.auth.shop_info.shop_id)
    },
    setAnimated () {
      if (this.getAppPrev.app_id !== null) {
        this.animiated1 = this.getAppPrev.app_id !== this.getAppCurrent.app_id
      } else {
        this.animiated1 = false
      }
    },
    setAnimated2 () {
      if (this.getAppPrev.app_id !== null) {
        this.animiated2 = this.getAppPrev.app_id !== this.getAppCurrent.app_id
      } else {
        this.animiated2 = false
      }
    },
  },
}
</script>

<style scoped>
  .subheader {
    display: flex;
    align-items: center;
  }
  .icon-box {
    width: 24px;
    height: 24px;
    margin-left: 10px;
    text-align: center;
    box-shadow: rgba(13, 13, 13, 0.1) 0 1px 0 0;
    border-radius: 2px;
    float: right;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .icon-box i {
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/components/apps/common/Header.vue